import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { string } from 'prop-types';
import PaddedContainer from '../containers/PaddedContainer';
import { ReactPageNavButton } from '../buttons/NavButtons';

const ErrorPage = ({ errorMessage, contactReason, svgImage, imageAltText }) => (
	<PaddedContainer>
		<Stack
			my={10}
			mx={{ xs: 3, sm: 10, md: 20, lg: 30 }}
			spacing={6}
			alignItems="center"
		>
			<Typography
				textAlign="center"
				color="primary"
				variant="h5"
				component="h1"
				data-testid="page-not-find-error-message"
			>
				{errorMessage}
			</Typography>
			<img src={svgImage} alt={imageAltText} />
			<ReactPageNavButton
				startIcon={<ArrowBackIcon />}
				variant="contained"
				href="/"
			>
				BACK TO HOME
			</ReactPageNavButton>
			<Divider sx={{ width: '70%' }} />
			<Typography variant="body1">
				Please{' '}
				<Link
					component={RouterLink}
					to="/contactus"
					variant="body2"
					underline="hover"
				>
					Contact Us
				</Link>{' '}
				if {contactReason}. We are here to help!
			</Typography>
		</Stack>
	</PaddedContainer>
);

ErrorPage.propTypes = {
	errorMessage: string,
	contactReason: string,
	svgImage: string,
	imageAltText: string,
};

export default ErrorPage;
